// Section 9 and 13: Jail. 8 build points, 4 wood and 8 stone; enables the imprisonment justice
// response; 4 cells (config.buildings.jail.cells per standing jail, read by the justice stream).
// Limit 1. Constants: config.buildings.jail.
import type { Config } from '../../config';
import { buildingEffectHook, noDeltas } from '../../core/content-helpers';
import { defineBuilding } from '../../core/registry';

export function jail(config: Config) {
  const c = config.buildings.jail;

  return defineBuilding({
    id: 'jail',
    label: 'Jail',
    section: 'S9',
    buildPoints: c.buildPoints,
    materials: { wood: c.wood, stone: c.stone },
    material: 'stone',
    beds: 0,
    plots: 0,
    capacity: {},
    limit: { kind: 'fixed', max: c.limit },
    modifierTargets: ['buildingEffect'],
    modifiers: buildingEffectHook('jail'),
    onComplete: noDeltas,
    onDamaged: noDeltas,
  });
}
